import { useEffect, useState } from 'react';
import type { StoryStatus } from './storyStatus';

export type ProgressEvent = {
  status: StoryStatus;
  detail?: string;
};

// Subscribes to the SSE progress stream for a single story. Returns the most
// recent event, or null until the first frame arrives. Closes the EventSource
// once the story enters a terminal state ('complete' / 'failed') or on unmount.
export function useStoryProgress(storyId: number | null): ProgressEvent | null {
  const [event, setEvent] = useState<ProgressEvent | null>(null);

  useEffect(() => {
    if (storyId === null) return;
    const es = new EventSource(`/api/stories/${storyId}/progress/`);
    es.onmessage = (msg) => {
      try {
        const data = JSON.parse(msg.data) as ProgressEvent;
        setEvent(data);
        if (data.status === 'complete' || data.status === 'failed') {
          es.close();
        }
      } catch {
        // Ignore malformed frames.
      }
    };
    es.onerror = () => es.close();
    return () => {
      es.close();
    };
  }, [storyId]);

  return event;
}
